<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container>
    <div class="slideshow-container">
      <!-- Full-width images with number and caption text -->
      <div class="mySlides">
        <div class="row row-poste">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Toc, toc, toc !</p>
            </div>
            <div class="right">
              <p>Je suis là !</p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>Ça alors, une poste en plein Jamborée !</p>
            </div>
            <div class="right">
              <p>Et oui ! Faut bien distribuer le courrier à tous ces petits scouts !</p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Vous en distribuez beaucoup ?</p>
            </div>
            <div class="right">
              <p>On expédie 50 000 lettres tous les jours.</p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>C’est énorme !</p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Vous êtes ?</p>
            </div>
            <div class="right">
              <p>Camille pour vous servir !</p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>
                On est arrivés en ballon, et il a eu de sérieux problèmes, on ne peut pas vous expliquer, ça serait très
                long, mais on aurait besoin de pièces de rechange.
              </p>
            </div>
            <div class="right">
              <p>Et vous pensez en trouver dans une poste ?</p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>
                Oh... Par contre, vous devez forcément bien connaître le Jamboree. Vous n'auriez pas des pistes pour
                nous aider ?
              </p>
            </div>
            <div class="right">
              <p>
                Figurez-vous que j'ai justement une lettre à faire parvenir à un dénommé Sartaq, il fait partie des
                scouts venus d'Inde. Ils ont de très beaux tissus ! Je ne sais pas s'ils sont adaptés pour un ballon,
                mais vous pouvez essayer.
              </p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>D'accord, si vous nous la donnez, on va leur porter !</p>
            </div>

            <div class="object" v-on:click="plusSlides(1)" @click="$emit('recupObject', 'lettre')">
              Récupérer la lettre.
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Facteurice.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div style="text-align: center;">
          <img src="https://cdn.exploreve.fr/content/cluedo/lettre v2.svg" height="400px" />
        </div>
      </div>
    </div>
    <br />

    <!-- The dots/circles -->
    <div style="text-align: center;">
      <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
      <span class="dot" v-on:click="currentSlide(1)"></span>
      <span class="dot" v-on:click="currentSlide(2)"></span>
      <span class="dot" v-on:click="currentSlide(3)"></span>
      <span class="dot" v-on:click="currentSlide(4)"></span>
      <span class="dot" v-on:click="currentSlide(5)"></span>
      <span class="dot" v-on:click="currentSlide(6)"></span>
      <span class="dot" v-on:click="currentSlide(7)"></span>
      <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
    </div>
  </b-container>
</template>

<script>
export default {
  data: function () {
    return {
      slideIndex: 1
    };
  },
  mounted() {
    this.currentSlide(1);
  },
  methods: {
    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },

    currentSlide(n) {
      if (this.slideIndex < n) return;
      this.slideIndex = n;
      this.showSlides();
    },

    showSlides() {
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (this.slideIndex > slides.length) {
        this.slideIndex = 1;
      }
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (let i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    }
  },
  components: {}
};
</script>

<style>
* {
  box-sizing: border-box;
}

.left {
  max-width: 300px !important;
}
</style>
